import NoData from "assets/svgs/no_data/NoData";
import React, { useEffect, useMemo, useState } from "react";
import { useManualUpdate } from "./store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder } from "modules/utilities/utility";

function TrackerTableData({ isLoading, trackerData }) {
  const header = [
    "Product Number",
    "Warehouses",
    "Highest Sequence Number",
    "Highest Cancellation Sequence Number",
  ];
  const { wareHousesData, fetchWareHouses } = useManualUpdate();
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [page, newPage] = useState(1);
  const [sortData, setSortedData] = useState([]);

  useEffect(() => {
    setSortedData(trackerData);
  }, [trackerData]);

  useEffect(() => {
    fetchWareHouses();
  }, []);

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  const warehouses = useMemo(() => {
    return wareHousesData?.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }, [wareHousesData]);

  const getWarehouse = (warehouse_id) => {
    const warehouseName = warehouses.find(
      (item) => item.value === warehouse_id
    );
    return warehouseName?.label;
  };

  return (
    <div>
      <div className="mt-1 shadow rounded">
        <div className="d-flex table-head rounded-top">
          {header?.map((item) => {
            return (
              <span className="p-3 fw-bold text-black flex-1">{item}</span>
            );
          })}
        </div>
        {isLoading ? (
          fourPlaceHolder()
        ) : filterData && filterData?.length ? (
          filterData.map((item, index) => {
            return (
              <div
                className={`d-flex table-row border- border-top-0 ${
                  index === trackerData?.mainData?.length - 1 &&
                  `rounded-bottom`
                }`}
              >
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {item?.product_name}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {getWarehouse(item?.warehouse_id)}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {item?.highest_sequence_number}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {item?.highest_cancellation_sequence_number}
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            {" "}
            No Data Available <NoData />
          </div>
        )}
      </div>
      <PaginationDiv
        paginationData={{ pageCount: pageCount || 1, page: page }}
        newPage={newPage}
        activePage={page}
      />
    </div>
  );
}

export default TrackerTableData;